import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../layout/header4";
import Footer from "../layout/footer";
import { useTranslation } from "react-i18next";
import emailjs from "emailjs-com";

const bg = require("../../images/banner/bnr1.jpg");

const Contact3 = () => {
  const { t } = useTranslation();
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          alert("An error occurred. Please try again.");
        }
      );
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>{t("contact.metaTitle")}</title>
        <meta name="description" content={t("contact.metaDescription")} />
        <meta name="keywords" content={t("contact.metaKeywords")} />
        <meta name="author" content="Gargouri Emballages" />
        <meta property="og:title" content={t("contact.metaTitle")} />
        <meta
          property="og:description"
          content={t("contact.metaDescription")}
        />
        <meta
          property="og:image"
          content="https://backend.gargouri-emballages.com/upload/products/images/img-Seau%20Rond%2030L-1746493801525-27qdce.jpg"
        />
        <meta
          property="og:url"
          content="https://www.gargouri-emballages.com/contact"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Header />
      <div className="page-content bg-white">
        <div
          className="dlab-bnr-inr overlay-black-middle bg-pt"
          style={{ backgroundImage: `url(${bg})` }}
        >
          <div className="container">
            <div className="dlab-bnr-inr-entry">
              <h1 className="text-white">{t("contact.title")}</h1>
              <div className="breadcrumb-row">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("contact.breadcrumb.home")}</Link>
                  </li>
                  <li>{t("contact.breadcrumb.contact")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="section-full content-inner bg-white contact-style-1">
          <div className="container">
            <div className="row">
              {/* Contact Info */}
              <div className="col-lg-4 col-md-6 d-flex m-b30">
                <div className="p-a30 border contact-area border-1 align-self-stretch radius-sm">
                  <h3 className="m-b5">{t("contact.quickContact")}</h3>
                  <p>{t("contact.quickContactText")}</p>
                  <ul className="no-margin">
                    <li className="icon-bx-wraper left m-b30">
                      <div className="icon-bx-xs border-1">
                        <Link to="#" className="icon-cell">
                          <i className="ti-location-pin"></i>
                        </Link>
                      </div>
                      <div className="icon-content">
                        <h6 className="text-uppercase m-tb0 dlab-tilte">
                          {t("contact.address")}:
                        </h6>
                        <p>km.9 Rte Teniour, Sfax</p>
                      </div>
                    </li>
                    <li className="icon-bx-wraper left m-b30">
                      <div className="icon-bx-xs border-1">
                        <Link to="#" className="icon-cell">
                          <i className="ti-email"></i>
                        </Link>
                      </div>
                      <div className="icon-content">
                        <h6 className="text-uppercase m-tb0 dlab-tilte">
                          {t("contact.email")}:
                        </h6>
                        <p>radhouane@gargouri-emballages.com</p>
                        <p>emna@gargouri-emballages.com</p>
                      </div>
                    </li>
                    <li className="icon-bx-wraper left">
                      <div className="icon-bx-xs border-1">
                        <Link to="#" className="icon-cell">
                          <i className="ti-mobile"></i>
                        </Link>
                      </div>
                      <div className="icon-content">
                        <h6 className="text-uppercase m-tb0 dlab-tilte">
                          {t("contact.phone")}
                        </h6>
                        <p>+216 74 846 750</p>
                      </div>
                    </li>
                  </ul>
                  <div className="m-t20">
                    <ul className="dlab-social-icon border dlab-social-icon-lg">
                      <li>
                        <Link
                          to="https://www.facebook.com/Gargouri.Emballages"
                          className="fa fa-facebook bg-primary"
                        ></Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="fa fa-linkedin bg-primary"
                        ></Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="col-lg-4 col-md-6 mb-4 m-b30 mb-md-0">
                <div className="p-a30 bg-gray clearfix radius-sm">
                  <h3 className="m-b10">{t("contact.sendMessage")}</h3>
                  <form
                    method="post"
                    className="dzForm"
                    ref={form}
                    onSubmit={sendEmail}
                  >
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            name="dzName"
                            type="text"
                            required
                            className="form-control"
                            placeholder={t("contact.namePlaceholder")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            name="dzEmail"
                            type="email"
                            className="form-control"
                            required
                            placeholder={t("contact.emailPlaceholder")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            name="dzMessage"
                            rows="4"
                            className="form-control"
                            required
                            placeholder={t("contact.messagePlaceholder")}
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <button type="submit" className="site-button">
                          <span>{t("contact.send")}</span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              {/* Map */}
              <div className="col-lg-4 d-flex m-b30">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3275.7271944274166!2d10.732373176584016!3d34.812804672880155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1301d3c251912e99%3A0x1eda4587d83ff8d6!2sGargouri%20Emballages!5e0!3m2!1sfr!2stn!4v1739283212329!5m2!1sfr!2stn"
                  className="align-self-stretch radius-sm"
                  style={{ border: "0", width: "100%", minHeight: "100%" }}
                  allowFullScreen
                  title="Gargouri Emballages"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Contact3;
